<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="userForm" :model="userForm"  :label-width="100" label-position="right" @submit.native.prevent>
        <Row type="flex" :gutter="12">
          <Col v-bind="grid">
            <FormItem label="幼儿园："  label-for="cardType">
              <Select v-model="userForm.school_id" class="perW100" @on-change="onChangeSchool">
                <Option :value="0">全部</Option>
                <Option v-for="item in school" :value="item.school_id" :key="item.school_id">
                  {{item.title}}
                </Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <Table :columns="columns2" :data="userInfo" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >
        <template slot-scope="{ row, index }" slot="status">
          <i-switch v-model="row.status" :value="row.status" :true-value="1" :false-value="0" @on-change="changeSwitch(row)">
          </i-switch>
        </template>
        <template slot-scope="{ row, index }" slot="role_name">
          <div v-for="(item,index) in row.role_name" :key="index">
            <Tag color="blue" >{{item}}</Tag>
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="is_dai">
          <span v-if="row.is_dai == 1">是</span>
          <span v-if="row.is_dai == 0">否</span>
        </template>
        <template slot-scope="{ row, index }" slot="is_repeat">
          <span v-if="row.is_repeat == 1">是</span>
          <span v-if="row.is_repeat == 0">否</span>
        </template>

        <template slot-scope="{ row, index }" slot="file">
          <a :href="row.file" target="_blank"><span v-if="row.file!= ''">点击打开文件</span></a>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a @click="edit(row.agent_id)">编辑</a>
          <Divider type="vertical"/>
          <a @click="del(row,'删除')">删除</a>
        </template>
      </Table>
      <Page :total="dataCount" :current="userForm.page" :page-size="userForm.limit" class="acea-row row-right page" show-total  @on-change="changepage"></Page>
    </Card>
<!--    <userEdit ref="userEdit" :id="userid" @updateStatusModel="updateStatusModel"></userEdit>-->
<!--    &lt;!&ndash;删除&ndash;&gt;-->
<!--    <modalSure ref="modalSure" title="代理" :id="userid" :modelApi="modelApi" @closeModal="closeModal"></modalSure>-->
  </div>
</template>

<script>
import { agentOderList, getSchool } from '@/api/agentOrder'
// import userEdit from './edit'
import modalSure from '@/components/modalSure'
export default {
  name: 'adminUser',
  components: { modalSure },
  inject: ['reload'],
  data () {
    return {
      grid: {
        xs: 24,
        sm: 24,
        md: 12,
        lg: 7,
        xl: 7
      },
      userForm: {
        page: 1,
        limit: 10,
        key: '',
        field_key: ''
      },
      // modelApi: delUser,
      dataCount: 0,
      field_key: 'all',
      userInfo: [],
      school: [],
      loading: false,
      userid: 0,
      columns2: [
        {
          title: '代理名称',
          key: 'agent_name',
          minWidth: 120
        },
        {
          title: '幼儿园',
          key: 'school',
          minWidth: 120
        },
        {
          title: '是否代买',
          slot: 'is_dai',
          minWidth: 120
        },
        {
          title: '是否可重复购买',
          slot: 'is_repeat',
          minWidth: 120
        },
        {
          title: '绘本数',
          key: 'book_num',
          minWidth: 120
        },
        {
          title: '书袋数',
          key: 'bookbag_num',
          minWidth: 120
        },
        {
          title: '总价',
          key: 'total_fee',
          minWidth: 120
        },
        {
          title: '文件',
          slot: 'file',
          minWidth: 120
        },
        {
          title: '提交时间',
          key: 'ctime',
          minWidth: 120
        },
        // {
        //   title: '操作',
        //   slot: 'action',
        //   fixed: 'right',
        //   minWidth: 120
        // }
      ]
    }
  },
  created () {
    this.userList()
    this.getSchool()
  },
  methods: {
    userList () {
      this.loading = true
      this.userForm.field_key = this.field_key === 'all' ? '' : this.field_key
      agentOderList(this.userForm).then(res => {
        let data = res.data
        this.userInfo = data.list
        this.dataCount = data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changepage (status) {
      this.userForm.page = status
      this.userList()
    },
    // 表格搜索
    userSearchs () {
      this.userForm.page = 1
      this.userList()
    },
    getSchool () {
      getSchool().then(async res => {
        this.school = res.data
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    onChangeSchool (val) {
      this.userForm.school_id = val
      this.userList()
    },
  }
}
</script>
